export { default } from './GamePage';
